export async function generateVisualMetaphor(description) {
  const response = await fetch("https://generate-image-519049312374.us-central1.run.app", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ description }),
  });
  if (!response.ok) throw new Error("Image generation failed");
  const data = await response.json();
  return data.imageUrl;
} 